export default __webpack_public_path__ + "static/media/nhs.06d188dc.svg";